import { Outlet } from 'react-router-dom';
import { useTenantEntity } from './tenant-entity-provider';
import { NotAuthorised } from './require-permission';

export function RequirePlatformPermission({ permission }: { permission?: string }) {
  const access = useTenantEntity();
  if (access.status === 'loading' || access.status === 'idle') return <div role="status">Checking access…</div>;
  const allowed = permission ? access.hasPlatformPermission(permission) : access.platformPermissions.some((key) => key.startsWith('platform.'));
  return allowed ? <Outlet /> : <NotAuthorised />;
}
